<template>
    <div class="layout-right">
            <div class="layout-right-top">
                <right-top bread="员工中心-员工管理"></right-top>
            </div>
            <div class="layout-right-body">
                <div class="item-box item-search">
                    <search-box placeholder="姓名/联系手机" :select-data="selectRoleData" :btns="searchOtherBtn"
                                @click="addEvent" @search="searchEvent"></search-box>
                </div>

                <div class="item-content" ref="itemContent">
                    <div class="table-box staff-list">
                        <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil" header-cell-class-name="table-ceil">
                            <el-table-column prop="username" label="用户名"></el-table-column>
                            <el-table-column prop="mobile" label="联系电话"></el-table-column>
                            <el-table-column prop="name" label="昵称">
                                <template slot-scope="data">
                                    {{data.row.name}}&nbsp;<el-tag v-if="data.row.job_name" type="warning">{{data.row.job_name}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="role_name" label="分类"></el-table-column>
                            <el-table-column prop="work_id" label="工号" width="100"></el-table-column>
                            <el-table-column label="操作" align="right" width="200">
                                <template slot-scope="data">
                                    <el-button
                                            size="mini"
                                            @click="handleEdit(data.$index, data.row)"
                                    >编辑</el-button>
                                    <el-button
                                            size="mini"
                                            type="danger"
                                            @click="handleDelete(data.$index, data.row)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page-box">
                        <el-pagination
                                @size-change="pageSizeChange"
                                @current-change="pageCurrentChange"
                                :current-page="page.nowPage"
                                :page-sizes="page.pageSizes"
                                :page-size="page.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="page.count">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div class="layout-right-bottom">
                <!--右下-->

            </div>
        </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import PopForm from "@/model/PopForm";
    import RightTop from "@/model/RightTop";
    export default {
        name: "StaffList",
        components: {RightTop, PopForm, SearchBox, Menu},
        data: () => ({
            tableData: [],
            editRules: {
                mobile: [
                    {required: true, message: "请填写联系电话"},
                ],
                role_id: [
                    {required: true, message: "请选择工种"},
                ],
                job_id: [
                    {required: true, message: "请选择职位"},
                ],
                user_name: [
                    {required: true, message: "请填写姓名"},
                ],
                nickname: [
                    {required: true, message: "请填写昵称"},
                ],
                work_id: [
                    {required: true, message: "请填写工号"},
                ]
            },
            role_list: [],
            searchOtherBtn: [
                {
                    label: "添加员工"
                }
            ],
            selectRoleData: {
                value: "",
                listData: []
            },
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            searchData: {
                keyword: "",
                selectVal: ""
            },
        }),
        mounted: function(){
            this.$store.commit("setMenuId", "4-3");

            this.loadRoleList();
            this.loadListData();

        },
        methods: {
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //添加按钮点击
            ,addEvent: function () {
                this.$root.go("staff/staff_info");
            }

            //编辑
            ,handleEdit: function (index, data) {
                this.$root.go("staff/staff_info?id=" + data.id);
            }

            //删除
            ,handleDelete: function (index, data) {
                obj.messageBox.confirm("你确定要删除员工[ "+ data.name +" ]吗？", "警告", {
                    confirmButtonText: '确认删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    obj.postData("store_staff/delete_staff", {id: data.id}, function (res) {
                        if(res.errcode === 0){
                            this.loadListData();
                            obj.message.success("删除成功");
                        } else {
                            obj.message.error("删除失败");
                        }
                    }.bind(this));

                } ).catch( () => {
                    return false;
                });
            }

            //加载职位
            ,loadRoleList: function () {
                obj.postData("store_role/get_role_list", {}, res => {
                    if(res.errcode === 0)
                        this.role_list = res.data;
                });
            }

            //加载列表数据
            ,loadListData: function () {
                let postData = {
                    offset: (this.page.nowPage - 1) * this.page.pageSize,
                    limit: this.page.pageSize,
                    keyword: this.searchData.keyword,
                    role_id: this.searchData.selectVal,
                };
                obj.postData("store_staff/get_list_data", postData, function (res) {
                    if(res.errcode === 0){
                        this.tableData = res.data.listData;
                        this.page.count = res.data.count;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }

            //搜索
            ,searchEvent: function (search) {
                this.searchData = search;
                this.loadListData();
            }
        },
        watch: {
            role_list: function (data) {
                let listData = [];
                data.forEach( v => {
                    listData.push({
                        label: v.role_name,
                        value: v.role_id
                    })
                });
                this.selectRoleData = {
                    value: "",
                    listData: listData
                };
            }
        }
    }
</script>

<style scoped>

</style>
